import Vue from 'vue';
import { CustomerDataInterface } from '@/types/store/landing/booking/customerDataInterface';

Vue.mixin({
  methods: {
    isCustomerData(customer: CustomerDataInterface): boolean {
      return Object.keys(customer).every(
        (el: string) =>
          customer[el as keyof CustomerDataInterface] !== '' && customer[el as keyof CustomerDataInterface] !== null,
      );
    },
  },
});
